import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Link, Text } from '@chakra-ui/react';
import { Alert, Form, Notification, Icon, ExternalLink } from '@whitbread-eos/atoms';
import { formatDataTestId, getSecureTwoURL, useCustomLocale, analytics, useSemanticTypography } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import { getPibLoginRedirectUrl } from '../../../common/Header/helpers/helpers';
import { loginFormConfig } from './loginFormConfig';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function LoginPIVariant(_ref) {
  var _labels$login, _headerInfoData$conte, _headerInfoData$conte2, _headerInfoData$conte3, _headerInfoData$conte4;
  var setIsLoginForm = _ref.setIsLoginForm,
    getFormState = _ref.getFormState,
    defaultValues = _ref.defaultValues,
    defaultErrors = _ref.defaultErrors,
    toggleLoginModal = _ref.toggleLoginModal,
    labels = _ref.labels,
    headerInfoData = _ref.headerInfoData;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    resetForm = _useState2[0],
    setResetForm = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isError = _useState4[0],
    setIsError = _useState4[1];
  var _useCustomLocale = useCustomLocale(),
    country = _useCustomLocale.country,
    language = _useCustomLocale.language;
  var getTypographyProps = useSemanticTypography();
  var baseDataTestId = 'Login';
  var onLinkClick = () => {
    setIsLoginForm(false);
  };
  var onSubmit = data => {
    var authIframe = document.getElementById('authIframe');
    if (authIframe !== null && authIframe !== void 0 && authIframe.contentWindow) {
      var message = JSON.stringify({
        action: 'login',
        username: data.email,
        password: data.password
      });
      authIframe.contentWindow.postMessage(message, getSecureTwoURL());
    }
  };
  useEffect(() => {
    var handleMessages = message => {
      if ((message === null || message === void 0 ? void 0 : message.origin) === getSecureTwoURL()) {
        var data = typeof (message === null || message === void 0 ? void 0 : message.data) === 'string' ? JSON.parse(message.data) : message.data;
        var action = data.action;
        if (action === 'loginError') {
          analytics.update({
            logInUnsuccessful: true
          });
          analytics.remove(['logInSuccessful']);
          setIsError(true);
        } else if (action === 'userLoggedIn') {
          analytics.update({
            logInSuccessful: true
          });
          analytics.remove(['logInUnsuccessful']);
          setResetForm(prev => prev + 1);
          setIsError(false);
          toggleLoginModal();
        }
      }
    };
    window.addEventListener('message', handleMessages);
    setResetForm(prev => prev + 1);
    return () => {
      window.removeEventListener('message', handleMessages);
    };
  }, []);
  return _jsxs(Flex, _objectSpread(_objectSpread({
    "data-testid": formatDataTestId(baseDataTestId, 'Container'),
    direction: "column"
  }, containerStyle), {}, {
    children: [_jsx(Text, _objectSpread(_objectSpread({}, headerStyle), {}, {
      "data-testid": formatDataTestId(baseDataTestId, 'Title'),
      children: labels.login.leisure.formLabel
    })), isError && _jsx(Flex, _objectSpread(_objectSpread({}, errorContainerStyles), {}, {
      children: _jsx(Notification, {
        title: labels === null || labels === void 0 || (_labels$login = labels.login) === null || _labels$login === void 0 ? void 0 : _labels$login.badCredentialsError,
        description: _jsxs(Link, {
          textDecoration: "underline",
          display: "block",
          "data-testid": formatDataTestId(baseDataTestId, 'ResetPassLink'),
          onClick: onLinkClick,
          children: [' ', labels.login.forgotPassword]
        }),
        variant: "alert",
        status: "warning",
        svg: _jsx(Alert, {})
      })
    })), _jsx(Form, _objectSpread({}, loginFormConfig({
      getTypographyProps,
      getFormState,
      defaultValues,
      defaultErrors,
      onSubmit,
      handleResetPass: onLinkClick,
      baseDataTestId,
      extraStyles: linkStyles,
      resetForm,
      fieldProps: {
        useTooltip: true
      },
      labels
    }))), _jsxs(Flex, _objectSpread(_objectSpread({
      direction: "row",
      justifyContent: "center",
      mb: "0rem",
      mt: "0rem"
    }, linkStyles), {}, {
      children: [_jsx(Text, {
        mb: "1.313rem",
        children: labels.login.signupMessage
      }), _jsxs(Link, {
        "data-testid": formatDataTestId(baseDataTestId, 'SignUpLink'),
        display: "block",
        textDecoration: "underline",
        pl: "xs",
        href: "".concat(getSecureTwoURL(), "/").concat(country, "/").concat(language, "/account/register.html"),
        children: [' ', labels.login.signupLink]
      })]
    })), ((headerInfoData === null || headerInfoData === void 0 || (_headerInfoData$conte = headerInfoData.content) === null || _headerInfoData$conte === void 0 || (_headerInfoData$conte = _headerInfoData$conte.authentication) === null || _headerInfoData$conte === void 0 || (_headerInfoData$conte = _headerInfoData$conte.login) === null || _headerInfoData$conte === void 0 || (_headerInfoData$conte = _headerInfoData$conte.business) === null || _headerInfoData$conte === void 0 ? void 0 : _headerInfoData$conte.travelForBusiness) || (headerInfoData === null || headerInfoData === void 0 || (_headerInfoData$conte2 = headerInfoData.content) === null || _headerInfoData$conte2 === void 0 || (_headerInfoData$conte2 = _headerInfoData$conte2.authentication) === null || _headerInfoData$conte2 === void 0 || (_headerInfoData$conte2 = _headerInfoData$conte2.login) === null || _headerInfoData$conte2 === void 0 || (_headerInfoData$conte2 = _headerInfoData$conte2.business) === null || _headerInfoData$conte2 === void 0 ? void 0 : _headerInfoData$conte2.businessDomain)) && _jsxs(_Fragment, {
      children: [_jsx(Flex, _objectSpread(_objectSpread(_objectSpread({
        direction: "row",
        justifyContent: "center"
      }, linkStyles), businessLoginStyles), {}, {
        children: (headerInfoData === null || headerInfoData === void 0 || (_headerInfoData$conte3 = headerInfoData.content) === null || _headerInfoData$conte3 === void 0 || (_headerInfoData$conte3 = _headerInfoData$conte3.authentication) === null || _headerInfoData$conte3 === void 0 || (_headerInfoData$conte3 = _headerInfoData$conte3.login) === null || _headerInfoData$conte3 === void 0 || (_headerInfoData$conte3 = _headerInfoData$conte3.business) === null || _headerInfoData$conte3 === void 0 ? void 0 : _headerInfoData$conte3.travelForBusiness) && _jsx(Text, {
          mb: "0px",
          children: headerInfoData.content.authentication.login.business.travelForBusiness
        })
      })), (headerInfoData === null || headerInfoData === void 0 || (_headerInfoData$conte4 = headerInfoData.content) === null || _headerInfoData$conte4 === void 0 || (_headerInfoData$conte4 = _headerInfoData$conte4.authentication) === null || _headerInfoData$conte4 === void 0 || (_headerInfoData$conte4 = _headerInfoData$conte4.login) === null || _headerInfoData$conte4 === void 0 || (_headerInfoData$conte4 = _headerInfoData$conte4.business) === null || _headerInfoData$conte4 === void 0 ? void 0 : _headerInfoData$conte4.businessDomain) && _jsx(Flex, _objectSpread(_objectSpread({
        direction: "row",
        justifyContent: "center",
        mb: "1.125rem",
        mt: "0.5rem"
      }, linkStyles), {}, {
        children: _jsxs(Link, {
          "data-testid": formatDataTestId(baseDataTestId, 'BusinessLink'),
          display: "block",
          textDecoration: "underline",
          pl: "xs",
          href: getPibLoginRedirectUrl(headerInfoData.content.authentication.login.business.businessDomain, language, country),
          target: "_blank",
          isExternal: true,
          children: [headerInfoData.content.authentication.login.business.businessLogin, _jsx(Icon, {
            ml: "4px",
            display: "inline-block",
            alignItems: "center",
            svg: _jsx(ExternalLink, {})
          })]
        })
      }))]
    })]
  }));
}
var businessLoginStyles = {
  borderTop: '1px solid var(--neutral-300-light-grey-4, #E0E0E0)',
  paddingTop: '2.125rem'
};
var containerStyle = {
  margin: {
    mobile: '1.5rem 1rem',
    sm: '1.5rem 2rem',
    md: '1.5rem 6.875rem'
  },
  width: {
    mobile: 'auto',
    xs: 'auto',
    md: '26rem'
  }
};
var headerStyle = {
  fontStyle: 'normal',
  fontWeight: 'semibold',
  fontSize: 'lg',
  lineHeight: 'var(--chakra-lineHeights-3)',
  textAlign: 'center',
  color: 'darkGrey1',
  mb: '2xl'
};
var linkStyles = {
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: 'md',
  lineHeight: 'var(--chakra-lineHeights-3)',
  color: 'btnSecondaryEnabled'
};
var errorContainerStyles = {
  marginBottom: '2xl'
};